import { HttpClient } from '@angular/common/http';
import { AppConfigSettings } from '@arc/arc-shared-frontend';
import { Observable } from 'rxjs/internal/Observable';
import {
  Country,
  CountryIsoNumberToAlpha3CodeMap,
  GetBankHolidayScheduleResponseV1,
  AutopayEligibilityResponse,
} from '../models';
import { PaymentSchedulerService } from './payment-scheduler.service';
import { of } from 'rxjs';

export class PaymentSchedulerPaymentLinksService extends PaymentSchedulerService {
  constructor(
    private httpClient: HttpClient,
    protected appConfig: AppConfigSettings,
  ) {
    super(appConfig);
  }

  getBankHolidayScheduleV1(
    tenantId: string,
    country: Country,
  ): Observable<GetBankHolidayScheduleResponseV1> {
    const countryCode = CountryIsoNumberToAlpha3CodeMap.get(country);
    return this.httpClient.get<GetBankHolidayScheduleResponseV1>(
      `${this.baseUrl}/v1/tenants/${tenantId}/bank/paymentlinks/holidayschedule?country=${countryCode}`,
    );
  }

  getCutoffTimeScheduleV1(
    tenantId: string,
    version: string,
  ): Observable<string> {
    return this.httpClient.get<string>(
      `${this.baseUrl}/v1/tenants/${tenantId}/ach/paymentlinks/versions/${version}/cutofftime`,
    );
  }

  getAutopayStatusV1() {
    return of();
  }

  enableAutopayV1() {
    return of();
  }

  disableAutopayV1() {
    return of();
  }

  getAutopayEligibilityV1(tenantId: string, accountNumber: string) {
    return this.httpClient.get<AutopayEligibilityResponse>(
      `${this.baseUrl}/v1/tenants/${tenantId}/accounts/${accountNumber}/autopaymenteligibility`,
    );
  }
}
